import {RootState} from "../../store";

const key = 'userAgreements';

export const userAgreementResultSelector = (state: RootState) => {
    return state[key].records.result;
};
